var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-floating-promises */
import { I18n } from "@aws-amplify/core";
import * as React from "react";
import { Themes } from "../../../theme/_Types";
import { joinClasses } from "../../../utils/Filters";
import { I18nLanguage } from "../../../utils/translations/I18n";
/**
 * misuse is thrown when FlexWrapper is consumed without a valid provider being
 * present.
 */
var misuse = new Error("misuse error: no BaseProvider in ancestors");
/**
 * BaseBindingInit
 */
export var baseBindingInit = function () { return ({
    setTheme: function (_to) {
        throw misuse;
    },
    getTheme: function () {
        throw misuse;
    },
    setLanguage: function (_to) {
        throw misuse;
    },
    getLanguage: function () {
        throw misuse;
    },
    themeIsLoaded: function () {
        throw misuse;
    },
}); };
/**
 *
 */
var BaseContext = React.createContext(baseBindingInit());
/**
 * BaseProvider is the Provider component of the Base component.
 */
var BaseProvider = /** @class */ (function (_super) {
    __extends(BaseProvider, _super);
    /**
     *
     * @param props
     */
    function BaseProvider(props) {
        var _a;
        var _this = _super.call(this, props) || this;
        _this.state = {
            activeTheme: props.theme,
            activeLanguage: (_a = props.language) !== null && _a !== void 0 ? _a : I18nLanguage.ENGLISH,
        };
        I18n.setLanguage(_this.state.activeLanguage);
        _this.setTheme = _this.setTheme.bind(_this);
        _this.setThemeReferences = _this.setThemeReferences.bind(_this);
        _this.getTheme = _this.getTheme.bind(_this);
        _this.setLanguage = _this.setLanguage.bind(_this);
        _this.getLanguage = _this.getLanguage.bind(_this);
        _this.isThemeLoaded = _this.isThemeLoaded.bind(_this);
        _this.getStyleSheet = _this.getStyleSheet.bind(_this);
        _this.themeIsLoaded = _this.themeIsLoaded.bind(_this);
        return _this;
    }
    /**
     *
     */
    BaseProvider.prototype.render = function () {
        var setTheme = this.setTheme;
        var getTheme = this.getTheme;
        var setLanguage = this.setLanguage;
        var getLanguage = this.getLanguage;
        var themeIsLoaded = this.themeIsLoaded;
        var clazzName = joinClasses("scl-b", this.props.className);
        return (React.createElement(BaseContext.Provider, { value: {
                setTheme: setTheme,
                getTheme: getTheme,
                setLanguage: setLanguage,
                getLanguage: getLanguage,
                themeIsLoaded: themeIsLoaded,
            } },
            React.createElement("div", { className: clazzName, style: this.props.style }, this.props.children)));
    };
    // We need to verify if this works (fleetinfo, bpc widget etc), before adding.
    // public componentDidMount() {
    //     if (this.props.dynamic) {
    //         this.setTheme(this.props.theme);
    //     }
    // }
    BaseProvider.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.theme !== this.props.theme) {
            this.setTheme(this.props.theme);
            if (this.props.refresh) {
                window.location.reload();
            }
        }
        if (this.props.language && (prevProps.language !== this.props.language)) {
            this.setLanguage(this.props.language);
        }
    };
    BaseProvider.prototype.getStyleSheet = function (unique_title) {
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for (var i = 0; i < document.styleSheets.length; i++) {
            var sheet = document.styleSheets[i];
            if (sheet.title === unique_title) {
                return sheet;
            }
        }
        return undefined;
    };
    BaseProvider.prototype.checkIfLoaded = function (val) {
        if (val) {
            // eslint-disable-next-line max-len
            return val.includes(".scl-preloader__wrapper:not(.scl-preloader__wrapper-forcedshow)") ? val : undefined;
        }
        return undefined;
    };
    BaseProvider.prototype.isThemeLoaded = function () {
        var e_1, _a;
        var _b;
        var returnVal = false;
        var ruleList = (_b = this.getStyleSheet("meta-css")) === null || _b === void 0 ? void 0 : _b.cssRules;
        if (ruleList) {
            try {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                for (var ruleList_1 = __values(ruleList), ruleList_1_1 = ruleList_1.next(); !ruleList_1_1.done; ruleList_1_1 = ruleList_1.next()) {
                    var rule = ruleList_1_1.value;
                    if (this.checkIfLoaded(rule.cssText)) {
                        returnVal = true;
                        break;
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (ruleList_1_1 && !ruleList_1_1.done && (_a = ruleList_1.return)) _a.call(ruleList_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
        return returnVal;
    };
    BaseProvider.prototype.themeIsLoaded = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var retries = 0;
            var checkIsThemeLoaded = function () {
                if (_this.isThemeLoaded()) {
                    resolve("success");
                }
                else {
                    if (retries < 30) {
                        setTimeout(function () { return checkIsThemeLoaded(); }, 200 + (retries * 100));
                        retries += 1;
                    }
                    else {
                        reject("error");
                    }
                }
            };
            checkIsThemeLoaded();
        });
    };
    /**
     * setTheme implements the setTheme method for the BaseBinding
     * provided to the Consumers.
     *
     * @param to the new theme priority.
     */
    BaseProvider.prototype.setTheme = function (to) {
        var _this = this;
        this.setState({
            activeTheme: to || this.props.theme,
        }, function () {
            if (_this.props.dynamic) {
                _this.setThemeReferences();
            }
        });
    };
    BaseProvider.prototype.setThemeReferences = function () {
        var brand = this.state.activeTheme;
        var metaCss = document.getElementById("meta-css");
        if (metaCss) {
            metaCss.setAttribute("href", "/assets/stylesheets/themes/" + brand + "/index.css");
        }
        var metaThemeColor = document.getElementById("meta-theme-color");
        if (metaThemeColor) {
            metaThemeColor.setAttribute("content", brand === Themes.DUTCHLEASE
                ? "#000" : brand === Themes.MAN ? "#303c49" : "#004666");
        }
        var metaThemeConfig = document.getElementById("meta-theme-config");
        if (metaThemeConfig) {
            metaThemeConfig.setAttribute("content", "/assets/images/themes/" + brand + "/icons/browserconfig.xml");
        }
        var metaFavicon = document.getElementById("meta-favicon");
        if (metaFavicon) {
            metaFavicon.setAttribute("href", "/assets/images/themes/" + brand + "/icons/favicon.ico");
        }
        var metaFaviconApple = document.getElementById("meta-favicon-apple");
        if (metaFaviconApple) {
            metaFaviconApple.setAttribute("href", "/assets/images/themes/" + brand + "/icons/apple-touch-icon.png");
        }
        var metaFavicon32 = document.getElementById("meta-favicon-32");
        if (metaFavicon32) {
            metaFavicon32.setAttribute("href", "/assets/images/themes/" + brand + "/icons/favicon-32x32.png");
        }
        var metaFavicon16 = document.getElementById("meta-favicon-16");
        if (metaFavicon16) {
            metaFavicon16.setAttribute("href", "/assets/images/themes/" + brand + "/icons/favicon-16x16.png");
        }
    };
    /**
     * getTheme implements the getFocus method for the BaseBinding
     * provided to the Consumers.
     *
     * @return the currently active theme priority.
     */
    BaseProvider.prototype.getTheme = function () {
        return this.state.activeTheme;
    };
    BaseProvider.prototype.setLanguage = function (to) {
        var _this = this;
        this.setState({
            activeLanguage: to || this.props.language,
            // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        }, function () { return I18n.setLanguage(_this.state.activeLanguage); });
    };
    BaseProvider.prototype.getLanguage = function () {
        return this.state.activeLanguage;
    };
    return BaseProvider;
}(React.Component));
export { BaseProvider };
/**
 * BaseConsumer is the Consumer component of the Base component.
 */
export var BaseConsumer = BaseContext.Consumer;
